<template>
    <v-card :class="`my-5 px-3 py-1 ${'candidate-card'}`" v-if="candidate && candidate.id">
        <v-col cols="12" class="d-flex pa-0 text-caption align-center justify-space-between">
            <v-col :class="`candidate-card__profession${isNotifiedAndStatusDiscarded ? '--disabled' : ''} px-0`" @click="showProfile">
                {{ candidate.user.professions[0] || candidate.user.professions[1] }}
                
            </v-col >
            <v-col class="d-flex justify-end align-center pa-0">
                <v-menu
                  open-on-hover
                  top
                  offset-y
                  :disabled="isNotifiedAndStatusDiscarded"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on" :class="`${isNotifiedAndStatusDiscarded ? 'grey--text text--lighten-4' : star.color[candidate.rate]}--text mx-1`">
                        {{star.icon}}
                    </v-icon>
                  </template>
                  <v-list dense>
                    <v-list-item @click="changeRate(0)">
                        <v-list-item-title>
                            <v-icon small class="green--text">
                                {{star.icon}}
                            </v-icon>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changeRate(1)">
                        <v-list-item-title>
                            <v-icon small class="yellow--text">
                                {{star.icon}}
                            </v-icon>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changeRate(2)">
                        <v-list-item-title>
                            <v-icon small class="red--text">
                                {{star.icon}}
                            </v-icon>
                        </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-checkbox v-model="check" :disabled="isNotified.discarded" dense hide-details color="#3BADFF" @click="clikedCheck" />
                <v-menu
                  top
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on" class="mx-1">
                            mdi-dots-vertical
                        </v-icon>
                    </template>
                    <v-list class="text-caption mx-0 py-0" dense>
                        <v-list-item link>
                            <v-list-item-title>
                                <v-menu
                                  open-on-hover
                                  right
                                  offset-y
                                  class="d-flex ma-0 pa-0 hola"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                      <span  v-bind="attrs" v-on="on">
                                          Mover
                                          <v-icon>
                                              mdi-chevron-right
                                          </v-icon>
                                      </span>
                                    </template>
                                  <v-list dense>
                                    <v-list-item
                                        link
                                        v-for="(item, index) in cols"
                                        :key="index"
                                        v-show="candidate.status.private !== item.status"
                                        @click="changeCol({to: item.status})"
                                    >
                                        <v-list-item-title>
                                            {{ item.name }}
                                        </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click="showProfile">
                            <v-list-item-title>
                                Ver Perfil
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item link  @click="downloadCV">
                            <v-list-item-title>
                                Descargar CV
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            link
                            @click="sendMail('no-context')"
                            v-if="candidate.status.private === 'sent' && offer.status !== 'close'"
                        >
                            <v-list-item-title>
                                Enviar Mensaje
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item  v-if="candidate.status.private !== 'sent' && offer.status !== 'close'">
                            <v-list-item-title>
                                <v-menu
                                  open-on-hover
                                  right
                                  offset-y
                                  class="d-flex ma-0 pa-0 hola"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <span  v-bind="attrs" v-on="on">
                                            Enviar Email
                                            <v-icon>
                                                mdi-chevron-right
                                            </v-icon>
                                        </span>
                                    </template>
                                  <v-list dense>
                                    <v-list-item
                                        link
                                        :disabled="isNotified[candidate.status.private]"
                                        @click="sendMail(candidate.status.private)"
                                    >
                                        <v-list-item-title>
                                            {{sendMailItem}}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        @click="sendMail('no-context')"
                                    >
                                        <v-list-item-title>
                                            Nuevo Mensaje
                                        </v-list-item-title>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-avatar :class="`d-flex ma-0 pa-0 ${isNotifiedAndStatusDiscarded ? 'image--disabled' : ''}`" size="25" @click="showProfile" >
                    <img :src="getAvatarPath(candidate.user)"/>
                </v-avatar>
            </v-col >
        </v-col>
        <v-col class="ma-0 pa-0" v-if="candidate.status.public === 'cancelled'">
                <small class="ma-0 pa-0" >
                    Postulación cancelada
                </small>
        </v-col>
        <v-col cols="12" :class="`candidate-card__name-yo${isNotifiedAndStatusDiscarded ? '--disabled' : ''} text-start pa-0`" @click="showProfile">
                <a @click="showProfile">
                    {{(`${candidate.user.firstName} ${candidate.user.lastName} ${candidate.user.birthAt.includes('0000') ? '' : '- ' + howOld(candidate.user.birthAt) + ' años'}`)}}
                </a>
        </v-col>
        <v-col cols="12" :class="`d-flex align-center justify-space-between px-0`">
            <span :class="`candidate-card__footer${isNotifiedAndStatusDiscarded ? '--disabled' : ''}`">
                Experiencia: {{ candidate.user.experience ? candidate.user.experience : 0 }} años
            </span>
            <!-- <span :class="`candidate-card__footer${isNotifiedAndStatusDiscarded ? '--disabled' : ''}`">
                {{`${getAnswerSalary}`}}
            </span> -->
        </v-col>
        <v-snackbar
            v-model="snackbar.status"
            :timeout="snackbar.timeout"
        >
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    @click="snackbar.status = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
        <CandidateDialog
            :dialog="dialog"
            :candidate="{...this.candidate, offer: this.offer}"
            :offer="offer"
            :cols="cols"
            @changeCol="changeCol"
            @send="sendMail"
            @close="dialog = false"
        />
    </v-card>
</template>

<script>
import CandidateDialog from "@/components/CandidateDialog";
import { datetime, currentImg } from "@/libs/mixins";

export default {
    name: "CandidateCard",
    props: ["candidate", "cols", "dataCard", "offer", "isChecked"],
    components: {
        CandidateDialog
    },
    mixins: [datetime, currentImg],
    data() {
        return {
            star: {
                icon: "mdi-star",
                color: ["green", "yellow", "red"]
            },
            check: false,
            snackbar: {
                text: "",
                timeout: 2000,
                status: false,
            },
            dialog: false,
            rateValue: 0,
        };
    },
    watch: {
        isChecked() {
            this.check = this.isChecked ? this.isChecked : false;    
        }
    },
    created() {
        this.rateValue = this.candidate.rate;
        this.check = this.isChecked ? this.isChecked : false;
    },
    computed: {
        isNotifiedAndStatusDiscarded() {
            return this.candidate?.notified?.discarded && this.candidate?.status?.private === "discarded";
        },
        sendMailItem() {
            const name = this.cols.find(c => this.dataCard.status === c.status).name;
            return name.substring(0, 1) + name.toLowerCase().substring(1, name.length - 1);
        },
        getAnswerSalary() {
            //if (this.candidate.salary && this.candidate.salary > 0) {
            //    return this.formatter(this.candidate.salary);
            //}
            //let returner = this.candidate.answers[0].split(".").join("");
            //returner = returner.split("$").join("");
            //let arraySearch = returner.split(" ");
            //let salary = arraySearch.find(item => parseInt(item) > 0);
            //return this.formatter(parseInt(salary));
            return 0;
        },
        getCheck() {
            return this.check;
        },
        isNotified() {
            return {
                sent: this.candidate?.notified?.sent,
                discarded: this.candidate?.notified?.discarded,
                interviewing: this.candidate?.notified?.interviewing,
                selected: this.candidate?.notified?.selected
            };
        }
    },
    methods: {
        sendMail(context) {
            this.$emit("send", { card: this.candidate, context });
        },
        clikedCheck() {
            this.$emit("checked", {
                state: this.check, 
                postId: this.candidate.id, 
                status: this.candidate.status.private
            });
        },
        downloadCV() {
            let filename = this.candidate.user.resume;
            if (filename === "") {
                this.snackbar.text = "No existe el archivo.";
                this.snackbar.status = true;
                return;
            }
            let url = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_RESUME_PATH + filename;

            fetch(url).then((t) => {
                return t.blob().then((b) =>  {
                    let a = document.createElement("a");
                    a.href = URL.createObjectURL(b);
                    a.setAttribute("download", filename);
                    a.click();
                });
            });
        },
        formatter(value) {
            const formatter = new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: this.offer.salary.currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            return formatter.format(value);
        },
        changeRate(rate) {
            this.rateValue = rate;
            this.$emit("rate", {
                rate: rate,
                candidate: this.candidate
            });
        },
        showProfile() {
            this.dialog = true;
        },
        changeCol(colStatus) {
            // TODO: hacer que esto funcione. 
            // Evaluar dejar aqui esto.
            this.$emit("changeCol", {
                from: { status: this.dataCard.status, index: this.dataCard.index },
                to: colStatus.to,
                card: this.candidate,
            });
            this.dialog = false;
        },
    }
};
</script>

<style scoped>

</style>
